import { labelOnly } from "../label-only";
import { toolInput } from "../tool-input";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";

export const integrationToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [
    "tool_search",
    (record) => {
      const query = toolInput.str(record.query);
      return labelOnly(
        query
          ? `Searched integrations for "${toolInput.truncate(query, 60)}"`
          : "Searched the connected integrations",
      );
    },
  ],
  [
    "tool_execute",
    (record) => {
      const target = toolInput.str(record.tool);
      return labelOnly(
        target
          ? `Ran ${toolInput.truncate(target, 60)}`
          : "Ran an integration tool",
      );
    },
  ],
];
